module.exports = __webpack_public_path__ + "static/media/trial1_1.a0b91533.png";